import React, { Component } from "react";
import Header from "../home/Header";
import Footer from "../home/Footer";
// import eventText from "../assets/img/eventText.jpg";
import cvent from "../assets/img/cvent-logo-white.png";
import "./EventText.css";
import Monica from "../assets/img/Monica.jpg";
import amanda from "../assets/img/amanda.jpg";
import sharon from "../assets/img/sharon.jpg";
import ingris from "../assets/img/ingris.jpg";
import michelle from "../assets/img/michelle.jpg";
import fSihl from "../assets/img/fSihl.jpg";
class EventText extends Component {
  render() {
    return (
      <>
        <Header />
        <section
          id="more-services"
          className="more-services"
          style={{ padding: "60px 150px" }}
        >
          {/* <div
            className="container"
            style={{ backgroundColor: "#85C1E9", padding: "2em" }}
          >
            <div className="row">
              <div
                className="col-lg-5 pt-4 pt-lg-0"
                data-aos="fade-up"
                data-aos-delay={300}
                id="eventTextCol"
                style={{ padding: "0em 2em" }}
              >
                <h2 style={{ color: "#000" }}>
                  <b>EVENTtext</b>
                </h2>
                <h5 style={{ color: "#000" }}>
                  Keep attendees informed, engaged and your event running
                  smooth.
                </h5>
              </div>
              <div
                className="col-lg-7"
                data-aos="fade-up"
                data-aos-delay={150}
                style={{ textAlign: "end" }}
              >
                <img
                  src={eventText}
                  className="img-fluid"
                  alt=""
                  data-aos="zoom-in"
                  data-aos-delay={500}
                  style={{ height: "410px" }}
                />
              </div>
            </div>
          </div> */}
          <div className="container">
            <div className="section-title ">
              <h2>How EVENTtext Works</h2>
            </div>
            <div className="col-md-12">
              <ul className="progressbar p-0">
                <li className="active"></li>
                <li></li>
                <li></li>
              </ul>
            </div>
            <div className="row" id="EVENTtextWorks">
              <div
                className="col-md-4 d-flex align-items-stretch"
                style={{ textAlign: "center" }}
              >
                <div className="card" data-aos="fade-up" data-aos-delay={100}>
                  <div className="card-body">
                    <p>
                      At the time of registration (or at check-in) event
                      attendees opt-in to receive texts.to a 10-digit number
                      assigned to your organization.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-4 d-flex align-items-stretch"
                style={{ textAlign: "center" }}
              >
                <div className="card" data-aos="fade-up" data-aos-delay={100}>
                  <div className="card-body">
                    <p>
                      You schedule texts to go out automatically and can send
                      texts manually as needed.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-4 d-flex align-items-stretch"
                style={{ textAlign: "center" }}
              >
                <div
                  className="card"
                  // style={{
                  //   backgroundImage: "url(" + { moreServices } + ")",
                  // }}
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div className="card-body">
                    <p>
                      Attendees are kept informed and on-track before, during
                      and after your event.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="container"
            style={{
              backgroundColor: "#85C1E9",
              padding: "4em",
              marginTop: "4em",
            }}
          >
            <div className="row">
              <div
                className="col-lg-9 pt-4 pt-lg-0"
                data-aos="fade-up"
                data-aos-delay={300}
                id="eventTextCol"
              >
                <h5 style={{ color: "#000" }}>
                  EVENTtext is integrated with the Cvent’s event registration
                  platform. Your attendees can opt-in to receive texts for your
                  event when they submit their registration through Cvent.
                </h5>
              </div>
              <div
                className="col-lg-3"
                data-aos="fade-up"
                data-aos-delay={150}
                style={{ textAlign: "end" }}
              >
                <img
                  src={cvent}
                  className="img-fluid"
                  alt=""
                  data-aos="zoom-in"
                  data-aos-delay={500}
                />
              </div>
            </div>
          </div>
          <div className="container" style={{ marginTop: "4em" }}>
            {" "}
            <div className="section-title ">
              <h2>Why texting is the perfect event communication tool…</h2>
            </div>
            <div className="row" id="EVENTtextWorks">
              <div
                className="col-md-6 d-flex align-items-stretch"
                style={{ textAlign: "center" }}
              >
                <div
                  className="card"
                  // style={{
                  //   backgroundImage: "url(" + { moreServices } + ")",
                  // }}
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div className="card-body">
                    <h5 className="card-title">EVERYONE TEXTS!</h5>
                    <p>
                      Over 95% of texts get read within 3 minutes. Most people
                      prefer texting to any other type of digital communication.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 d-flex align-items-stretch"
                style={{ textAlign: "center" }}
              >
                <div
                  className="card"
                  // style={{
                  //   backgroundImage: "url(" + { moreServices } + ")",
                  // }}
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div className="card-body">
                    <h5 className="card-title">HIGHLY ADAPTABLE </h5>
                    <p>
                      From simple text alerts to personalized, interactive
                      experiences that capture and display data, texting can do
                      much more than you may know.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 d-flex align-items-stretch mt-4"
                style={{ textAlign: "center" }}
              >
                <div
                  className="card"
                  // style={{
                  //   backgroundImage: "url(" + { moreServices } + ")",
                  // }}
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div className="card-body">
                    <h5 className="card-title">SIMPLE TO MANAGE</h5>
                    <p>
                      Setup is fast and simple and can easily be handled by
                      anyone on your team — no techie or SMS expert required.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 d-flex align-items-stretch mt-4"
                style={{ textAlign: "center" }}
              >
                <div
                  className="card"
                  // style={{
                  //   backgroundImage: "url(" + { moreServices } + ")",
                  // }}
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div className="card-body">
                    <h5 className="card-title">BUDGET FRIENDLY</h5>
                    <p>
                      For a fraction of the cost of the typical event app or
                      trade show expense you can have a custom texting system
                      that will simplify your tasks and impress your attendees.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section id="pricing" className="pricing ">
            <div className="container">
              <div className="section-title ">
                <h2>Pick the plan that fits your event.</h2>

                <h3>
                  <b>Single-event plans:</b>
                </h3>
              </div>
              <div className="row">
                <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
                  <div
                    className="box"
                    data-aos="zoom-in"
                    data-aos-delay={100}
                    style={{ padding: "0em" }}
                    id="planBox"
                  >
                    <div style={{ background: "#F5B041", paddingTop: "1em" }}>
                      <h3 className="singlePlanHeader">SMALL</h3>
                      <h4 style={{ color: "#fff" }}>
                        <sup>$</sup>299
                      </h4>
                    </div>
                    <p>For events with less than 100 attendees.</p>
                    <ul>
                      <li style={{ borderTop: "1px solid lightgray" }}>
                        500 SMS Credits
                      </li>
                      <li>Reminders/Alerts</li>
                      <li>SMS Scheduling</li>
                      <li>1 hr training</li>
                      <li>7-day texting window</li>
                      <li>Cvent Integration</li>
                      <li style={{ borderBottom: "none" }}>
                        Overages: $10 per block of 200
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
                  <div
                    className="box"
                    data-aos="zoom-in"
                    data-aos-delay={100}
                    style={{ padding: "0em" }}
                    id="planBox"
                  >
                    <div style={{ background: "#F5B041", paddingTop: "1em" }}>
                      <h3 className="singlePlanHeader">SMALL-MID</h3>
                      <h4 style={{ color: "#fff" }}>
                        <sup>$</sup>399
                      </h4>
                    </div>
                    <p style={{ padding: "0em 1em" }}>
                      For events with 100 to 300 attendees.
                    </p>
                    <ul>
                      <li style={{ borderTop: "1px solid lightgray" }}>
                        1,500 SMS credits
                      </li>
                      <li>Reminders/Alerts</li>
                      <li>SMS Scheduling</li>
                      <li>1 hr training</li>
                      <li>30-day texting window</li>
                      <li>Cvent Integration</li>
                      <li style={{ borderBottom: "none" }}>
                        Overages: $10 per block of 200
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
                  <div
                    className="box"
                    data-aos="zoom-in"
                    data-aos-delay={100}
                    style={{ padding: "0em" }}
                    id="planBox"
                  >
                    <div style={{ background: "#F5B041", paddingTop: "1em" }}>
                      <h3 className="singlePlanHeader">MID</h3>
                      <h4 style={{ color: "#fff" }}>
                        <sup>$</sup>699
                      </h4>
                    </div>
                    <h3>
                      <b>MOST POPULAR</b>
                    </h3>
                    <p>For events with less than 100 attendees.</p>
                    <ul>
                      <li style={{ borderTop: "1px solid lightgray" }}>
                        5,000 SMS Credits
                      </li>
                      <li>Reminders/Alerts</li>
                      <li>SMS Scheduling</li>
                      <li>1 hr training</li>
                      <li>7-day texting window</li>
                      <li>Cvent Integration</li>
                      <li style={{ borderBottom: "none" }}>
                        Overages: $10 per block of 200
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
                  <div
                    className="box"
                    data-aos="zoom-in"
                    data-aos-delay={100}
                    style={{ padding: "0em" }}
                    id="planBox"
                  >
                    <div style={{ background: "#F5B041", paddingTop: "1em" }}>
                      <h3 className="singlePlanHeader">LARGE</h3>
                      <h4 style={{ color: "#fff" }}>
                        <sup>$</sup>1,299
                      </h4>
                    </div>
                    <p>For events with 1,000 to 2,000 attendees.</p>
                    <ul>
                      <li style={{ borderTop: "1px solid lightgray" }}>
                        12,000 SMS credit
                      </li>
                      <li>Reminders/Alerts</li>
                      <li>SMS Scheduling</li>
                      <li>1 hr training</li>
                      <li>90-day texting window</li>
                      <li>Cvent Integration</li>
                      <li style={{ borderBottom: "none" }}>
                        Overages: $10 per block of 400
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="section-title" style={{ marginTop: "4em" }}>
                <h3>
                  <b>Annual subscription plans:</b>
                </h3>
              </div>
              <div className="row">
                <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
                  <div
                    className="box"
                    data-aos="zoom-in"
                    data-aos-delay={100}
                    style={{ padding: "0em" }}
                    id="annualPlanBox"
                  >
                    <h3>1K SUBSCRIPTION</h3>

                    <h4>
                      <sup>$</sup>299
                    </h4>

                    <p>12-mo subscription PAID MONTHLY</p>
                    <ul>
                      <li>
                        <i className="fa fa-check"></i>1,000 SMS credits/month*
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Overages: $10 per block
                        of 200
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
                  <div
                    className="box"
                    data-aos="zoom-in"
                    data-aos-delay={100}
                    style={{ padding: "0em" }}
                    id="annualPlanBox"
                  >
                    <h3>2K SUBSCRIPTION</h3>

                    <h4>
                      <sup>$</sup>399
                    </h4>

                    <p>12-mo subscription PAID MONTHLY</p>
                    <ul>
                      <li>
                        <i className="fa fa-check"></i>2,000 SMS credits/month*
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Overages: $10 per block
                        of 200
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
                  <div
                    className="box"
                    data-aos="zoom-in"
                    data-aos-delay={100}
                    style={{ padding: "0em" }}
                    id="annualPlanBox"
                  >
                    <h3>5K SUBSCRIPTION</h3>

                    <h4>
                      <sup>$</sup>499
                    </h4>

                    <p>12-mo subscription PAID MONTHLY</p>
                    <ul>
                      <li>
                        <i className="fa fa-check"></i>5,000 SMS credits/month*
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Overages: $10 per block
                        of 200
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
                  <div
                    className="box"
                    data-aos="zoom-in"
                    data-aos-delay={100}
                    style={{ padding: "0em" }}
                    id="annualPlanBox"
                  >
                    <h3>12K SUBSCRIPTION</h3>

                    <h4>
                      <sup>$</sup>999
                    </h4>

                    <p>12-mo subscription PAID MONTHLY</p>
                    <ul>
                      <li>
                        <i className="fa fa-check"></i>5,000 SMS credits/month*
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Overages: $10 per block
                        of 200
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row" style={{ marginTop: "2em" }}>
                <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
                  <div
                    className="box"
                    data-aos="zoom-in"
                    data-aos-delay={100}
                    style={{ padding: "1em" }}
                    id="annualPlanBox"
                  >
                    <h2>OR</h2>

                    <h4>
                      <sup>$</sup>3,289
                    </h4>

                    <p>(12-mos. paid upfront)</p>
                    <h5 className="fw-bold">A savings of $299/year</h5>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
                  <div
                    className="box"
                    data-aos="zoom-in"
                    data-aos-delay={100}
                    style={{ padding: "1em" }}
                    id="annualPlanBox"
                  >
                    <h2>OR</h2>

                    <h4>
                      <sup>$</sup>4,389
                    </h4>

                    <p>(12-mos. paid upfront)</p>
                    <h5 className="fw-bold">A savings of $399/year</h5>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
                  <div
                    className="box"
                    data-aos="zoom-in"
                    data-aos-delay={100}
                    style={{ padding: "1em" }}
                    id="annualPlanBox"
                  >
                    <h2>OR</h2>

                    <h4>
                      <sup>$</sup>5,489
                    </h4>

                    <p>(12-mos. paid upfront)</p>
                    <h5 className="fw-bold">A savings of $499/year</h5>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
                  <div
                    className="box"
                    data-aos="zoom-in"
                    data-aos-delay={100}
                    style={{ padding: "1em" }}
                    id="annualPlanBox"
                  >
                    <h2>OR</h2>

                    <h4>
                      <sup>$</sup>10,989
                    </h4>

                    <p>(12-mos. paid upfront)</p>
                    <h5 className="fw-bold">A savings of $999/year</h5>
                  </div>
                </div>{" "}
              </div>
            </div>
          </section>
          <div
            className="container"
            style={{
              backgroundColor: "#85C1E9",
              padding: "4em",
              marginTop: "4em",
            }}
          >
            <div className="row">
              <div
                className="col-lg-9 pt-4 pt-lg-0"
                data-aos="fade-up"
                data-aos-delay={300}
                id="eventTextCol"
              >
                <h2>Ready to sign up?</h2>
                <h6>
                  Contact us today so we can help you choose the right event
                  plan.
                </h6>
              </div>
              <div
                className="col-lg-3"
                data-aos="fade-up"
                data-aos-delay={150}
                style={{ textAlign: "end" }}
              >
                <button
                  className="btn btn-primary"
                  style={{
                    background: "#fff",
                    color: "#000",
                    border: "1px solid #fff",
                  }}
                >
                  <a
                    href="/contactus"
                    className="btn-buy fw-bold"
                    style={{
                      color: "#fff",
                    }}
                  >
                    Contact Us{" "}
                  </a>
                </button>
              </div>
            </div>
          </div>

          <div className="container" style={{ marginTop: "5em" }}>
            <div className="section-title" data-aos="fade-up">
              <h2>Testimonials</h2>
              <p>What event professionals are saying…</p>
            </div>

            <div className="row " data-aos="fade-up" data-aos-delay={400}>
              <div className="col-md-4 " id="testimonialsBox">
                <div className="box">
                  <p>
                    “I use EVENTtext to keep our competitors, officials, staff
                    and spectators in the loop on all event details. Our guests
                    love it and my boss is very happy with it! GivBee’s support
                    is GREAT!! They even answered my 911 text at 8pm on a
                    Friday!! The value is Tremendous!”
                  </p>
                  <div>
                    <img
                      src={Monica}
                      className="img-fluid"
                      alt=""
                      style={{ width: "30%" }}
                    />
                  </div>
                  <p id="testimonialsName">
                    <b>Monica Blanco</b>
                  </p>
                  <p style={{ fontSize: "13px" }}>
                    Director of Special Events The Grand Oaks Resort
                  </p>
                </div>
              </div>
              <div className="col-md-4 " id="testimonialsBox">
                <div className="box">
                  <p>
                    “Since we have started using EVENTtext, we have had 80%
                    opt-in results for each event and attendees are satisfied
                    with the level of engagement the notifications provide. One
                    thing I liked was I was able to direct people to the agenda
                    pages housed on CVENT and provide realtime updates. I find
                    the tool to be a great enhancement to my goal to go
                    paperless for all meetings and provide easy information to
                    attendees. I would recommend EVENTtext to all event planners
                    and suggest you have fun with it!”
                  </p>
                  <div>
                    <img
                      src={amanda}
                      className="img-fluid"
                      alt=""
                      style={{ width: "30%" }}
                    />
                  </div>
                  <p id="testimonialsName">
                    <b>Amanda Young</b>
                  </p>
                  <p style={{ fontSize: "13px" }}>America’s Events Leader</p>
                  <h6>GE Healthcare</h6>
                </div>
              </div>
              <div className="col-md-4 " id="testimonialsBox">
                <div className="box">
                  <p>
                    “GivBee has been an amazing partner in helping us improve
                    both our ability to reach out to attendees during our
                    seminars, and our ability to give attendees an even more
                    worthwhile experience. The introduction of the EVENTtext
                    service really brought our attendees an easy way to stay on
                    top of pop-up events, schedule changes, venue changes, etc.”
                  </p>
                  <div>
                    <img
                      src={sharon}
                      className="img-fluid"
                      alt=""
                      style={{ width: "30%" }}
                    />
                  </div>
                  <p id="testimonialsName">
                    <b>Sharon Boothe</b>
                  </p>
                  <p style={{ fontSize: "13px" }}>VP of Programs</p>
                  <h6>Mass Torts Made Perfect</h6>
                </div>
              </div>
            </div>
            <div
              className="row "
              data-aos="fade-up"
              data-aos-delay={400}
              style={{ marginTop: "3em" }}
            >
              <div className="col-md-4 " id="testimonialsBox">
                <div className="box">
                  <p>
                    “It was our first time using EVENTtext, but our attendees
                    embraced it as much as we did. The more creative we were,
                    the more they engaged. It was our best addition to our event
                    customer service and marketing, and we’ll definitely use it
                    for all of our other shows.”
                  </p>
                  <div>
                    <img
                      src={ingris}
                      className="img-fluid"
                      alt=""
                      style={{ width: "30%" }}
                    />
                  </div>
                  <p id="testimonialsName">
                    <b>Ingrid Thorson</b>
                  </p>
                  <p style={{ fontSize: "13px" }}>
                    Dir. Marketing Communications
                  </p>
                  <h6>National Golf Course Owners Assoc.</h6>
                </div>
              </div>
              <div className="col-md-4 " id="testimonialsBox">
                <div className="box">
                  <p>
                    We had more than 1,000 people attend this year’s Summit and
                    I can think of no more efficient and reliable way to
                    communicate with them than with the texts we were able to
                    send through EVENTtext.
                  </p>
                  <div>
                    <img
                      src={michelle}
                      className="img-fluid"
                      alt=""
                      style={{ width: "30%" }}
                    />
                  </div>
                  <p id="testimonialsName">
                    <b>Michelle Swanner</b>
                  </p>
                  <p style={{ fontSize: "13px" }}>Executive Director</p>
                  <h6>The National Trial Lawyers</h6>
                </div>
              </div>
              <div className="col-md-4 " id="testimonialsBox">
                <div className="box">
                  <p>
                    “EVENTText made running our week-long client appreciation
                    trip seamless. Being able to quickly communicate with our
                    guests helped us to provide a great experience and
                    pre-scheduling most everything took a lot off our plate once
                    on-site! We received so many comments about how efficient
                    things were, thanks to the ability to text!”
                  </p>
                  <div>
                    <img
                      src={fSihl}
                      className="img-fluid"
                      alt=""
                      style={{ width: "30%" }}
                    />
                  </div>
                  <p id="testimonialsName">
                    <b>Kimberly Gomlak</b>
                  </p>
                  <p style={{ fontSize: "13px" }}>
                    Vice President, Marketing The Counsel Financial
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="container"
            style={{
              backgroundColor: "#85C1E9",
              padding: "4em",
              marginTop: "4em",
            }}
          >
            <div className="row">
              <div
                className="col-lg-12 pt-4 pt-lg-0"
                data-aos="fade-up"
                data-aos-delay={300}
                id="eventTextCol"
              >
                <h2>
                  <b>
                    To schedule a custom demo, text “EVENT” to (844) 679-2172.
                  </b>
                </h2>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  }
}

export default EventText;
